let mountedFlows = 0;

export function markBuildFlowOnScreen(): () => void {
  mountedFlows += 1;
  return () => {
    mountedFlows -= 1;
  };
}

export const isBuildFlowOnScreen = () => mountedFlows > 0;
